import React from 'react';
import PropTypes from 'prop-types';

import { Loading } from 'sarsaparilla';

const propTypes = {
  loading: PropTypes.bool.isRequired,
  size: PropTypes.oneOf(['large', 'small']).isRequired,
  className: PropTypes.string,
  children: PropTypes.node
};

const defaultProps = {
  loading: false,
  className: ''
};

export default function LoadingWrapper(props) {
  const { className, loading, size, children } = props;

  if (loading) {
    return <div className={`${className} loading-wrapper is-not-loaded`}><Loading size={size} /></div>;
  }

  return <div className={`${className} loading-wrapper is-loaded`}>{children}</div>;
}

LoadingWrapper.propTypes = propTypes;
LoadingWrapper.defaultProps = defaultProps;
